import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import '../scss/HeaderFooterBase.scss';

function renderChildren(children) {
    /**
     * Force to use single children. Otherwise it will be hard to find
     * particular children and force any style.
     */
    React.Children.only(children);
    /**
     * Here more condition can be added if you want to force particular behaviour
     * on any components
     */
    return children;
}


/**
 *  A particular item in Frame and can be child of
 * left, middle or right container.
 */

const FrameItem = ({
    children,
    className,
    variant,
    ...otherProps
}) => (
    <div
        className={classNames(`ccd${variant}__item`, className)}
        {...otherProps}>
        {renderChildren(children)}
    </div>
);

FrameItem.propTypes = {
    /**
     * variant for frame component
     */
    variant: PropTypes.oneOf(['Header', 'Footer']),
};

FrameItem.defaultProps = {
    variant: 'Header',
};

export default FrameItem;
